export default {
  name: "Footer-index"
};